import { JSONSchemaType } from 'ajv'

export interface IConnectorTypeFormData {
  connectorTypeName: string
  isInactive: boolean
}

const ConnectorTypeSchema: JSONSchemaType<IConnectorTypeFormData> = {
  type: 'object',
  properties: {
    connectorTypeName: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    isInactive: {
      type: 'boolean',
      default: false,
    },
  },
  required: ['connectorTypeName'],
  additionalProperties: false,
}

export default ConnectorTypeSchema
